import { EVENT_PURCHASE_CLAIMED } from './events';
import { reportError } from './error-reporter';

const callListener = (listener, payload) => {
  return fetch(listener.url, {
      method: 'POST',
      body: JSON.stringify(payload),
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
    })
    .catch((error) => {
      reportError({ error, component: 'WebhookLayer', params: payload });
    });
}

const dispatchWebhook = (listeners, payload) => {
  return Promise.all(
    listeners.map((listener) => callListener(listener, payload))
  );
}

const webhookDispatcher = {
  dispatchPurchaseClaimed(purchase) {
    const { merchant: { frontEndWebhookListeners } } = purchase;
    const payload = {
      type: EVENT_PURCHASE_CLAIMED,
      data: {
        purchase: {
          id: purchase.id,
          slug: purchase.slug,
        },
      },
    };
    return dispatchWebhook(frontEndWebhookListeners, payload);
  }
};

export default webhookDispatcher;



// WEBPACK FOOTER //
// ./src/lib/webhook-dispatcher.js